export const WHITE = '#fff';
export const ORANGE = '#FF7800';
export const BLUE = '#2D364C';
export const LIGHT_BLUE = '#F5F5FA';
export const GREEN = '#0CB754';
export const DASH_COLOR = 'rgba(45,54,76,0.26)';
export const GREY = '#71819A';
export const GREY_LIGHT = '#EAEAEA';